import "./AboutUs.scss";
import ButtonPrimary from "../../components/shared/ButtonPrimary";

import AboutUsBg from "../../assets/images/about-us/about-us-bg.svg";
import MainAgent from "../../assets/images/about-us/main-agent.png";
import LeftAgent from "../../assets/images/about-us/left-agent.png";
import RightAgent from "../../assets/images/about-us/right-agent.png";
import Esphere from "../../assets/images/about-us/esphere.png";
import Sparkle from "../../assets/images/sparkle.svg";

export default function AboutUs() {
	return (
		<>
			<div className="about-us" id="about-us">
				<div className="about-us-content-wrapper">
					<div className="about-us-content">
						<h3 className="about-us-title" data-aos="fade-up">
							<span className="title-txt">About Us</span>
						</h3>

						<p className="about-us-desc" data-aos="fade-up" data-aos-delay="100">
							<span className="emphasis">Vernus AI</span> is
							transforming Web3 development with autonomous AI
							agents, making blockchain innovation smarter,
							faster, and more efficient. From website creation
							and smart contract automation to market insights and
							wallet tracking, Vernus AI simplifies complex
							tasks—no technical expertise needed.
							<br />
							<br />
							More than just a toolset, Vernus AI is a
							decentralized ecosystem built on transparency,
							privacy, and innovation...
						</p>

						<div className="about-us-btns" data-aos="fade-up" data-aos-delay="200">
							<ButtonPrimary className="about-us-btn">
								Learn More
							</ButtonPrimary>
						</div>
					</div>

					<div className="about-us-img">
						<img
							className="about-us-bg"
							src={AboutUsBg}
							alt="About Us Background"
							width={422}
							height={418}
						/>
						<img
							className="main-agent"
							src={MainAgent}
							alt="Main Agent"
							width={747}
							height={561}
						/>
						<img
							className="left-agent"
							src={LeftAgent}
							alt="Left Agent"
							width={180}
							height={126}
							data-aos="fade-up-left"
						/>
						<img
							className="right-agent"
							src={RightAgent}
							alt="Right Agent"
							width={75}
							height={56}
							data-aos="fade-up-right"
						/>
						<img
							className="esphere shake-slow-3"
							src={Esphere}
							alt="Esphere"
							width={293}
							height={300}
						/>
						<img
							className="left-sparkle shake-slow-4"
							src={Sparkle}
							alt="Sparkle"
							width={201}
							height={201}
						/>
						<img
							className="right-sparkle shake-slow-2"
							src={Sparkle}
							alt="Sparkle"
							width={201}
							height={201}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
